import type { ReduxState } from "@dashboard/types/reduxState";
import type { Theme } from "@dashboard/types/theme";

import { RestaurantChangedAction } from "./restaurantReducer";

export type ThemeReducerAction =
  | RestaurantChangedAction
  | {
      type: "FETCHED_THEMES";
      payload: { restaurantUuid: string; themes: Theme[] };
    };

export const themeReducer: (
  state: ReduxState["theme"] | undefined,
  action: ThemeReducerAction
) => ReduxState["theme"] = (
  state: ReduxState["theme"] = {
    initialThemesLoading: true,
    themes: [],
    themesRestaurantUuid: null,
  },
  action: ThemeReducerAction
) => {
  switch (action.type) {
    case "RESTAURANT_CHANGED":
      // Drop the themes too: the sidebar logo reads them directly, so keeping
      // them would show the previous restaurant's logo until the new listener
      // delivers.
      return {
        initialThemesLoading: true,
        themes: [],
        themesRestaurantUuid: null,
      };
    case "FETCHED_THEMES":
      return {
        initialThemesLoading: false,
        themes: action.payload.themes,
        themesRestaurantUuid: action.payload.restaurantUuid,
      };
    default:
      return state;
  }
};
